
export const ImgCompo = [
    [{
        image : './photography/bestPhoto.jpg'
        ,id: 1
    },
    {
        image : './photography/boyLaughEdit.jpg'
        ,id: 2
    },

    {
        image : './photography/waterBoat.jpg'
        ,id: 3
    },
    {
        image : './photography/coconutAndPlant.jpg'
        ,id: 4
    },
    {
        image : './photography/cycle.jpg'
        ,id: 5
    },
    {
        image : './photography/dewPic.jpg'
        ,id: 6
    },
    {
        image : './photography/reflectionImg.jpg'
        ,id: 7
    },
    {
        image : './photography/dog1.jpg'
        ,id: 8
    },
    {
        image : './photography/dog2.jpg'
        ,id: 9
    },
    {
        image : './photography/education.jpg'
        ,id: 10
    },
    {
        image : './photography/evngLight.jpg'
        ,id: 11
    },
    {
        image : './photography/evngStand.jpg'
        ,id: 12
    },
    {
        image : './photography/firePic.jpg'
        ,id: 13
    },
    {
        image : './photography/flowePic2.jpg'
        ,id: 14
    },
    {
        image : './photography/friendshipEdit.jpg'
        ,id: 15
    },
    {
        image : './photography/funnyFightPic.jpg'
        ,id:16
    },
    {
        image : './photography/funnyKidsPic.jpg'
        ,id:17
    },{
        image : './photography/grandpaSmoke.jpg'
        ,id:18
    },

    {
        image : './photography/grasshopper.jpg'
        ,id:19
    },{
        image : './photography/greenPic.jpg'
        ,id:20
    },
    {
        image : './photography/hardWorkFire.jpg'
        ,id:21
    },
    {
        image : './photography/heroPic.jpg'
        ,id:22
    },
    {
        image : './photography/jokerAndGlass.jpg'
        ,id:23
    },
    {
        image : './photography/kidsLaugh.jpg'
        ,id:24
    },
    {
        image : encodeURI('./photography/little3Edit.jpg')
        ,id:25
    },
    {
        image : './photography/microPlant.jpg'
        ,id:26
    },
    {
        image : './photography/nitc.jpg'
        ,id:27
    },
    {
        image : './photography/waterBoat.jpg'
        ,id:28
    },
    {
        image : './photography/rosePic.jpg'
        ,id:29
    },
    {
        image : './photography/skyandLeaves.jpg'
        ,id:30
    },
    {
        image : './photography/skypic.jpg'
        ,id:31
    },
    {
        image : './photography/smallCoconut.jpg'
        ,id:32
    },
    {
        image : './photography/spyderWeb.jpg'
        ,id:33
    },
    {
        image : './photography/standingPic.jpg'
        ,id:34
    },
    {
        image : './photography/studentPic.jpg'
        ,id:35
    },
    {
        image : './photography/threeMonkiesPic.jpg'
        ,id:36
    },
    {
        image : './photography/todayChildren.jpg'
        ,id:37
    },
    {
        image : './photography/tyreImg.jpg'
        ,id:38
    },
    {
        image : './photography/oldRustIron.jpg'
        ,id:39
    },
    {
        image : './photography/waterSprinkler.jpg'
        ,id:40
    },
    {
        image : './photography/waterSprinkle2.jpg'
        ,id:41
    },
    {
        image : './photography/wheelShow.jpg'
        ,id:42
    }],

    [{
        image: encodeURI('photoshop/batman edit.jpg')
        ,id:1
    },
    {
        image : encodeURI('photoshop/brockLesner.jpg')
        ,id:2
    },
    {
        image : encodeURI('photoshop/broken poster.jpg')
        ,id:3
    },
    {
        image : encodeURI('photoshop/hulk.jpg')
        ,id:4
    },
    {
        image : encodeURI('photoshop/iit.jpg')
        ,id:5
    },
    {
        image : encodeURI('photoshop/glass jar and flies.jpg')
        ,id:6
    },
    {
        image : encodeURI('photoshop/love-edit.jpg')
        ,id:7
    },
    {
        image : encodeURI('photoshop/light and chair.jpg')
        ,id:8
    },
    {
        image : encodeURI('photoshop/NIKE SHOES PHOTOSHOP.jpg')
        ,id:9
    },{
        image : encodeURI('photoshop/My edit 2.jpg')
        ,id:10
    },
    {
        image : encodeURI( 'photoshop/new year poster.jpg')
        ,id:11
    },
    {
        image : encodeURI('photoshop/shoe sports.jpg')
        ,id:12
    },
    {
        image :encodeURI('photoshop/cyber type.jpg')
        ,id:13
    },
    {
        image : encodeURI('photoshop/girl-edit.jpg')
        ,id:14
    },
    {
        image : encodeURI('photoshop/SURYA VIKRAM.jpg')
        ,id:15
    },
    {
        image : encodeURI('photoshop/The Exorcist Naveen.jpg')
        ,id:16
    },
    {
        image : encodeURI('photoshop/watch helios.jpg')
        ,id:17
    },
    {
        image : encodeURI('photoshop/ironAntMan.jpg')
        ,id:18
    },
    {
        image : encodeURI('photoshop/tshirt designing.jpg')
        ,id:19
    },
    {
        image : encodeURI('photoshop/salaar edit.jpg')
        ,id:20
    },
    {
        image : encodeURI('photoshop/super man 2 edit.jpg')
        ,id:21
    },
    {
        image : encodeURI('photoshop/super man spookey edit.jpg')
        ,id:22
    },
    {
        image : encodeURI('photoshop/cricters with smooth texture.jpg')
        ,id:23
    },

],
    
    [{
        image : encodeURI('artwork/batmanart.jpg')
        ,id:1
    },
    {
        image : encodeURI('artwork/oldManArt.jpg')
        ,id:2
    },
    {
        image : encodeURI('artwork/pregnantart.jpg')
        ,id:3
    },
    {
        image : encodeURI('artwork/skull.jpg')
        ,id:4
    },
    {
        image : encodeURI('artwork/babyCouple.jpg')
        ,id:5
    },
    {
        image : encodeURI('artwork/boyGirlEvng.jpg')
        ,id:6
    },
    {
        image : encodeURI('artwork/bulb.jpg')
        ,id:7
    },
    {
        image : encodeURI('artwork/butterfly.jpg')
        ,id:8
    },
    {
        image : encodeURI('artwork/cartoons.jpg')
        ,id:9
    },
    {
        image : encodeURI('artwork/dancingArt.jpg')
        ,id:10
    },
    {
        image : encodeURI('artwork/death.jpg')
        ,id:11
    },
    {
        image : encodeURI('artwork/deer.jpg')
        ,id:12
    },
    {
        image : encodeURI('artwork/devil.jpg')
        ,id:13
    },
    {
        image : encodeURI('artwork/ironManHeart.jpg')
        ,id:14
    },
    {
        image : encodeURI('artwork/dog.jpg')
        ,id:15
    },
    {
        image : encodeURI('artwork/girlWindow.jpg')
        ,id:16
    },
    {
        image : encodeURI('artwork/oldWoman.jpg')
        ,id:17
    },
    {
        image : encodeURI('artwork/oldManWithDog.jpg')
        ,id:18
    },
    {
        image : encodeURI('artwork/hateness.jpg')
        ,id:19
    },
    {
        image : encodeURI('artwork/devilHeadphones.jpg')
        ,id:20
    },
    {
        image : encodeURI('artwork/man.jpg')
        ,id:21
    },
    {
        image : encodeURI('artwork/girlWithWings.jpg')
        ,id:22
    },

    {
        image : encodeURI('artwork/coupleSleep.jpg')
        ,id:23
    },
    {
        image : encodeURI('artwork/coupleRomance.jpg')
        ,id:24
    },
    {
        image : encodeURI('artwork/death.jpg')
        ,id:25
    },
       {
        image : encodeURI('artwork/spyGob.jpg')
        ,id:26
    },
    {
        image : encodeURI('artwork/Vendor.jpg')
        ,id:27
    },
    {
        image : encodeURI('artwork/venomArt.jpg')
        ,id:28
    },
    {
        image : encodeURI('artwork/Zombieart.jpg')
        ,id:29
    },
    {
        image : encodeURI('artwork/ripArt.jpg')
        ,id:30
    },
    {
        image : encodeURI('artwork/fArt.jpg')
        ,id:31
    },
    {
        image : encodeURI('artwork/flower.jpg')
        ,id:32
    },

    {
        image : encodeURI('artwork/hairArt.jpg')
        ,id:33
    },
    {
        image : encodeURI('artwork/hands.jpg')
        ,id:34
    },
    {
        image : encodeURI('artwork/hugart.jpg')
        ,id:35
    },
    {
        image : encodeURI('artwork/kissart.jpg')
        ,id:36
    },
    {
        image : encodeURI('artwork/lizard.jpg')
        ,id:37
    },
    {
        image : encodeURI('artwork/nobithaSuzuka.jpg')
        ,id:38
    },
      {
        image : encodeURI('artwork/hanuman.jpg')
        ,id:39
    },
      {
        image : encodeURI('artwork/scary.jpg')
        ,id:40
    },
      {
        image : encodeURI('artwork/solo.jpg')
        ,id:41
    },

]
]


//photography, photoshop, arts